import { Component, OnInit, EventEmitter, Input, OnChanges, SimpleChanges, Output, OnDestroy } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AppLayer, LayerLoadState } from 'app/services/layer.service';
// import { LayerQcService } from 'app/services/layer-qc.service';
// import { UserService } from 'app/services/user.service';
import { FilterOption, MainDataService, ModelMenuItemKey } from 'app/services/main-data.service';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-qc-filters-my-layers',
  templateUrl: './qc-filters-my-layers.component.html',
  styleUrls: ['./qc-filters-my-layers.component.css']
})
export class QcFiltersMyLayersComponent implements OnInit, OnDestroy {
	// @Input() myLayer: MyLayer;
	// isQc: boolean;

	isCheckAll: boolean;
	filterOptions: FilterOption[] = [];
	private filterOptionsAll: FilterOption[] = [];

	qcState: LayerLoadState;
	// qcStateText: string;

	selectedLayer: AppLayer;
	addressCateCode: string;

	@Input() showFishboneFilter: boolean;

	// @Output() onChange: EventEmitter<QcFilterChangeData> = new EventEmitter();
	// @Output() clickRunQc: EventEmitter<any> = new EventEmitter();

	showCheckAllBox: boolean;

	modelKey: ModelMenuItemKey;

	private mouseoverCodeTimeout;

	private filterOptionsSub: Subscription;
	private modelSub: Subscription;
	private selectedLayerSub: Subscription;

	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private mainDataService: MainDataService,
		private tooltipHelpService: TooltipHelpService
	) { }

	clickApply() {
		this.activityService.applyAttrFilterSubject.next();
		// this.activityService.refreshData.next()
	}

	toggleCheckAll() {
		// if (!this.isQc) {
		// 	return;
		// }
		this.isCheckAll = !this.isCheckAll;
		this.filterOptionsAll.forEach((d) => d.isSelected = this.isCheckAll);
		this.triggerQcChange();
	}
	toggleFilterOption(option: FilterOption, skipGetData?: boolean) {
		// Make sure only one filter is selected
		if (option.isSelected) {
			this.filterOptionsAll.forEach(o => {
				if (o !== option && o.isSelected) {
					o.isSelected = false;
				}
			})
		}
		this.triggerQcChange(skipGetData);
	}

	onMouseoverCode(option: FilterOption) {
		this.mouseoverCodeTimeout = setTimeout(() => {
			const codes = [option.value];
			this.tooltipHelpService.lastTooltipsBS.next({
				codes: codes
			});
		}, this.tooltipHelpService.delayTime);
	}
	onMouseoutCode() {
		if (this.mouseoverCodeTimeout) {
			clearTimeout(this.mouseoverCodeTimeout);
		}
	}

	private filterFilterOptions() {
		if (this.selectedLayer && this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
			const toRemove = [];
			switch (this.modelKey) {
				case 'L':
					this.filterOptions = this.filterOptionsAll.filter(i => {
						if (i.value.startsWith('FS')) {
							const isShow = i.value.endsWith('L');
							if (!isShow && i.isSelected) {
								toRemove.push(i);
							}
							return isShow;
						}
						return true;
					});
					break;
				case 'N':
					this.filterOptions = this.filterOptionsAll.filter(i => {
						if (i.value.startsWith('FS')) {
							const isShow = !i.value.endsWith('L');
							if (!isShow && i.isSelected) {
								toRemove.push(i);
							}
							return isShow;
						}
						return true;
					});
					break;
				default:
					this.filterOptions = this.filterOptionsAll;
					break;
			}
			if (toRemove.length) {
				toRemove.forEach(i => {
					i.isSelected = false;
					this.toggleFilterOption(i);
				})
			}
		} else {
			this.filterOptions = this.filterOptionsAll;
		}
	}
	private checkShowCheckAllBox() {
		this.showCheckAllBox = this.qcState.num > 1.51 && !!(this.filterOptionsAll.find(o => !!o.count));
	}
	private triggerQcChange(skipGetData?: boolean, isQcUserPrefer?: boolean) {
		this.mainDataService.qcFilterInfo.next({
			// isQcFilter: this.isQc,
			isCheckAll: this.isCheckAll,
			isQcUserPrefer: isQcUserPrefer,
			filterOptions: this.filterOptionsAll,
			skipGetData: skipGetData,
			source: 'filterTab'
		});
	}

	// runQc() {
	// 	this.clickRunQc.emit();
	// }

	ngOnInit() {
		let isInit = true;

		this.addressCateCode = this.attrIndexService.cateCodeAddress;
		
		this.filterOptionsSub = this.mainDataService.qcFilterInfo.subscribe((data) => {
			if (isInit) {
				this.isCheckAll = data.isCheckAll;
				this.filterOptionsAll = data.filterOptions;
			} else if (data.source !== 'filterTab') {
				this.filterOptionsAll = data.filterOptions;
				if (data.hasOwnProperty('isCheckAll') && data.isCheckAll !== this.isCheckAll) {
					this.toggleCheckAll();
				}
			}
			this.filterFilterOptions();
			const selectedLayer = this.selectedLayer;
			if (selectedLayer) {
				this.qcState = selectedLayer.state;
				// this.qcStateText = this.attrIndexService.layerLoadStateTextMap[this.qcState];
				this.checkShowCheckAllBox();
			}
		});
		this.modelSub = this.mainDataService.modelBS.subscribe(async data => {
			if (this.modelKey !== data) {
				this.modelKey = data;
				this.filterFilterOptions();
			}
		});
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(data => {
			this.selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		})
		isInit = false;
	}
	ngOnChanges(changes: SimpleChanges) {
		// if (changes.myLayer && !changes.myLayer.firstChange) {
		// 	this.onLayerChange(changes.myLayer.currentValue);
		// }
	}
	ngOnDestroy() {
		this.filterOptionsSub.unsubscribe();
		this.modelSub.unsubscribe();
		this.selectedLayerSub.unsubscribe();
	}
}
